import { LinkProps } from '@tanstack/react-router';

import { getTenantRoutePath } from 'common/utils/getTenantRoutePath';

import { getTenantConfig } from '../../../config/tenantConfig';

export type Group = {
  name: string;
  groupId?: string;
  links: Link[];
};

type Link = {
  name: string;
  to?: LinkProps['to'];
  url?: string;
  preload?: false | 'intent' | undefined;
  badge?: number | null;
};

export const getAccessibleLinks = (
  merchantId: string,
  initialGroups: Group[],
  userRoles: string[],
) =>
  initialGroups.map((group) => {
    const newGroup: Group = { ...group };
    const merchantConfig = getTenantConfig(merchantId);

    const links = newGroup.links.filter((link) => {
      if (link.to) {
        const routePath = getTenantRoutePath(merchantId, link.to);
        const canAccess =
          routePath &&
          (merchantConfig.routes[routePath] || []).some((role) => userRoles.includes(role));

        return canAccess;
      }

      if (link.url) {
        const urlAccessRoles = merchantConfig.urls?.[link.url] || [];
        return urlAccessRoles.some((urlAccessRole) => userRoles.includes(urlAccessRole));
      }

      return false;
    });

    return {
      ...newGroup,
      links,
    };
  });
